var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmergency = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 14.81q.424 0 .713-.287A.97.97 0 0 0 10 13.81a.97.97 0 0 0-.287-.712A.97.97 0 0 0 9 12.81a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712q0 .426.287.713.288.287.713.287m-1-4h2v-6H8zm-2.75 8L0 13.56v-7.5L5.25.81h7.5L18 6.06v7.5l-5.25 5.25zm.85-2h5.8l4.1-4.1v-5.8l-4.1-4.1H6.1L2 6.91v5.8z"
})));
export default SvgEmergency;